<template>
  <div class="active-manager">
    <component ref="stepRef" v-bind:is="currStep.component"></component>
    <div class="buttom-nav">
      <div v-if="currStep.prev" @click="prevStep" class="prev">
        <img :src="currStep.prev.icon" />
        <div>{{ currStep.prev.text }}</div>
      </div>
      <div v-if="currStep.next" @click="nextStep" class="next">
        {{ nextText || currStep.next }}
      </div>
    </div>
    <taking-hint-dialog
      :type="showTakingHintDialogType"
      v-model="showTakingHintDialog"
    ></taking-hint-dialog>
  </div>
</template>

<script>
const ActiveInfoConfirm = (resolve) =>
  require(["./ActiveInfoConfirm.vue"], resolve);

const ActiveTakingPicturesHint = (resolve) =>
  require(["./ActiveTakingPicturesHint.vue"], resolve);

const ActiveTakingPictures = (resolve) =>
  require(["./ActiveTakingPictures.vue"], resolve);

const ActiveTakingPicturesComplete = (resolve) =>
  require(["./ActiveTakingPicturesComplete.vue"], resolve);

const steps = [
  {
    title: "激活信息确认",
    component: ActiveInfoConfirm,
    prev: {
      text: "修改信息",
      icon: require("../../assets/ic_change_info.png"),
    },
    next: "信息无误，下一步",
  },
  {
    title: "拍摄手机照片",
    component: ActiveTakingPicturesHint,
    prev: {
      text: "上一步",
      icon: require("../../assets/back.svg"),
    },
    next: "下一步",
  },
  {
    title: "拍摄手机照片",
    component: ActiveTakingPictures,
    prev: {
      text: "上一步",
      icon: require("../../assets/back.svg"),
    },
    next: "开始拍摄",
  },
  {
    title: "拍摄手机照片",
    component: ActiveTakingPicturesComplete,
    next: "提交激活",
  },
];
import Vue from "vue";
import TakinngHintDialog from "../../components/TakingHintDialog.vue";
Vue.component("taking-hint-dialog", TakinngHintDialog);
import { httpOpen } from "../../scripts/network";
import { dataBase64toBlob } from "../../scripts/util.js";
import { login } from "../../scripts/auth";
export default {
  name: "ActiveStepsManager",
  data() {
    return {
      info: {
        name: "",
        phone: "",
        imei: "",
        sn: "",
        code: "",
        brand: "",
        images: {
          imei: null,
          screenClose: null,
          back: null,
        },
      },
      steps: steps,
      step: 0,
      showTakingHintDialog: false,
      showTakingHintDialogType: 0,
      nextText: null,
    };
  },
  provide() {
    return {
      injectStepInfo: this.info,
      showTakinngHint: this.showTakinngHint,
      goBackStep: this.prevStep,
      updateNextText: this.updateNextText,
    };
  },
  watch: {
    step(val) {
      document.title = this.steps[val].title;
      this.nextText = null;
    },
  },
  computed: {
    currStep() {
      return this.steps[this.step];
    },
  },
  mounted() {
    document.title = this.steps[0].title;
    this.info.code = this.$route.params.code;
    this.info.name = this.$route.query.name;
    this.info.phone = this.$route.query.phone;
    this.info.imei = this.$route.query.imei;
    this.info.sn = this.$route.query.sn;
    this.info.brand = this.$route.query.brand;
  },
  created() {},
  methods: {
    updateNextText(text) {
      this.nextText = text;
    },
    prevStep() {
      let currentCompont = this.$refs.stepRef.prev;
      if (currentCompont && currentCompont.prev) {
        if (!currentCompont.prev()) {
          return;
        }
      }
      if (this.step === 0) {
        this.$router.back(-1);
      } else {
        this.step = this.step - 1;
      }
    },
    async nextStep() {
      let currentCompont = this.$refs.stepRef;
      if (currentCompont && currentCompont.nextStep) {
        let inter = await currentCompont.nextStep();
        if (!inter) {
          return;
        }
      }
      if (this.step === this.steps.length - 1) {
        this.complete();
      } else {
        this.step = this.step + 1;
      }
    },
    async complete() {
      this.$loading.show("正在上传");
      try {
        let images = [];
        let imei = await this.uploadImage(this.info.images.imei);
        if (!imei) {
          this.$loading.hide();
          this.$taost("上传失败，请稍后重试");
          return;
        }
        images.push({ AppendixType: 10, AppendixContent: imei });
        let screenClose = await this.uploadImage(this.info.images.screenClose);
        if (!screenClose) {
          this.$loading.hide();
          this.$taost("上传失败，请稍后重试");
          return;
        }
        images.push({ AppendixType: 10, AppendixContent: screenClose });
        let back = await this.uploadImage(this.info.images.back);
        if (!back) {
          this.$loading.hide();
          this.$taost("上传失败，请稍后重试");
          return;
        }
        images.push({ AppendixType: 10, AppendixContent: back });
        const ret = await httpOpen("/WuYouCard/ActivationWfcOrder", {
          type: "post",
          body: {
            ActivationCode: this.info.code,
            IMEICode: this.info.imei,
            SerialNumber: this.info.sn,
            BrandName: this.info.brand,
            MobilePhone: this.info.phone,
            AppendixList: images,
          },
        });
        this.$loading.hide();
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (ret.Status) {
          const id = ret.Data.SysNo;
          this.$toast("激活成功");
          this.$router.replace({
            path: "/care/active/" + id + "/submit-success",
            query: {
              code: this.info.code,
              name: this.info.name,
              phone: this.info.phone,
              imei: this.info.imei,
              sn: this.info.sn,
              brand: this.info.brand,
            },
          });
        } else {
          this.$toast(ret.Message);
        }
      } catch (e) {
        this.$loading.hide();
        console.log(e);
        this.$toast("上传失败，请稍后重试");
      }
    },
    async uploadImage(image) {
      try {
        let formData = new FormData();
        const data = dataBase64toBlob(image);
        formData.append("file", data);
        const ret = await httpOpen("/Common/ImageFileUpload", {
          type: "POST",
          timeout: 90000,
          body: formData,
        });
        if (ret.Status) {
          return ret.Data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    showTakinngHint(type) {
      this.showTakingHintDialogType = type;
      this.showTakingHintDialog = true;
    },
  },
};
</script>
<style lang="less" scoped>
@nav-height: calc(56px + env(safe-area-inset-bottom));
.active-manager {
  width: 100vw;
  height: 100vh;
  flex-direction: column;
  background: #f4f4f4;
  .active-content {
    height: calc(100vh - @nav-height);
  }
  .buttom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: @nav-height;
    background: white;
    border-top: 1px solid #dfdfdf;
    padding: 0 24px env(safe-area-inset-bottom) 24px;
    box-sizing: border-box;
    .prev {
      font-size: 10px;
      text-align: center;
      line-height: 10px;
      img {
        height: 16px;
      }
    }
    .next {
      flex: 1 1;
      background: linear-gradient(90deg, #f4e4cc -3%, #f0c587 96%);
      text-align: center;
      height: 38px;
      border-radius: 19px;
      color: #4d3621;
      line-height: 38px;
      font-weight: 500;
    }
    .prev + .next {
      margin-left: 16px;
    }
  }
}
</style>
